import { css, getAppStore } from 'jimu-core';
const oppositePosition = {
    left: 'right',
    right: 'left',
    top: 'bottom',
    bottom: 'top'
};
function opposite(position, isRTL) {
    if (!isRTL) {
        return oppositePosition[position];
    }
    return (position === 'left' || position === 'right') ? position : oppositePosition[position];
}
function flipPlacement(position, isRTL) {
    if (!isRTL)
        return position;
    if (position === 'left')
        return 'right';
    if (position === 'right')
        return 'left';
    return position;
}
export function popperPointer(arrowStyle) {
    var _a;
    const placements = ['left', 'right', 'top', 'bottom'];
    const isRTL = getAppStore().getState().appContext.isRTL;
    const border = arrowStyle === null || arrowStyle === void 0 ? void 0 : arrowStyle.border;
    const background = arrowStyle === null || arrowStyle === void 0 ? void 0 : arrowStyle.background;
    const size = ((_a = arrowStyle === null || arrowStyle === void 0 ? void 0 : arrowStyle.size) !== null && _a !== void 0 ? _a : 12) + 'px';
    return css `
    .jimu-popper--arrow {
      position: absolute;
      &::before,
      &::after {
        content: " ";
        display: block;
        width: 0;
        height: 0;
        border: ${size} solid transparent;
        position: absolute;
      }
    }
    &[data-popper-placement^="top"],
    &[data-popper-placement^="bottom"] {
      .jimu-popper--arrow {
        ${isRTL ? 'right: 50%' : 'left: 50%'};
        &::before,
        &::after {
          transform: translateX(-50%);
        }
      }
    }
    &[data-popper-placement^="left"],
    &[data-popper-placement^="right"] {
      .jimu-popper--arrow {
        top: 50%;
        &::before,
        &::after {
          transform: translateY(-50%);
        }
      }
    }
    ${placements.map((placement) => {
        var _a, _b;
        return css `
      &[data-popper-placement^="${placement}"] {
        .jimu-popper--arrow {
          ${opposite(placement, isRTL)}: -${size};
          &::before,
          &::after {
            border-${opposite(placement, isRTL)}-width: 0;
            border-${flipPlacement(placement, isRTL)}-color: ${(_a = border === null || border === void 0 ? void 0 : border.color) !== null && _a !== void 0 ? _a : 'inherit'};
            ${opposite(placement, isRTL)}: 0;
          }
          &::after {
            border-${flipPlacement(placement, isRTL)}-color: ${background !== null && background !== void 0 ? background : 'inherit'};
            ${opposite(placement, isRTL)}: ${(_b = border === null || border === void 0 ? void 0 : border.width) !== null && _b !== void 0 ? _b : '1px'};
          }
        }
      }
    `;
    })}
  `;
}
